<template>
<div>
  
      <v-toolbar-title class="header-left mt-2">

        <div class="logo" router to="/" @click="gotoMainPage">
          <i class="logo-icon material-icons">assignment_ind</i>
          <div class="logo-title">OneChart</div>
        </div>

      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div class="header-right">
        <v-menu v-if="user" bottom offset-y class="main-menu-label">
          <v-layout row align-center justify-end
              class="profile-content" 
              slot="activator">
            <div class="username mr-1">{{ username }}</div>
            <avatar class="ma-1" :size="35" backgroundColor="#1565C0" color="white" :fontSize="16" :scaleFont="false" :name="username" :src="userImageUrl" />
            <icon icon="keyboard_arrow_down" :size="12"></icon>
          </v-layout>
          <v-list dense>
            <v-list-tile 
            v-for="option in menuItems" :key="option.label"
            @click="option.action()">
              <v-list-tile-title class="main-menu-label">
                <v-layout row align-center>
                  <icon class="menu-icon" v-if="option.icon" 
                    :icon="option.icon" :size="20"></icon>
                  {{ $t(option.label) }}
                </v-layout>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>

  <!-- Activity Toolbar -->
  <!-- <v-toolbar class="activity-toolbar" color="white" dense flat>

    <v-btn class="back" flat color="primary"
    @click="$router.go(-1)">
        <v-icon>keyboard_arrow_left</v-icon>
        Back
    </v-btn>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-btn class="search" icon flat color="primary"
    @click="toggleSearch"> -->
        <!-- <i class="icon-search"></i> -->
        <!-- <icon icon="search"></icon>
    </v-btn> -->

      <!-- Search Toolbar  -->
    <!-- <transition name="slide-y-transition"> -->
    <!-- <transition name="slide-fade">
      <v-layout v-if="showSearch" row align-center class="searchToolbar" dense flat>
        <div class="search">
          <icon icon="search"></icon>
        </div>
        <input class="search-input ml-2 mr-2" placeholder="Search" v-focus>
        <v-btn icon flat
          @click="toggleSearch">
              <icon icon="close"></icon>
          </v-btn>
      </v-layout>
    </transition>
  </v-toolbar> -->



<!-- Filter Toolbar -->
<!-- <v-divider></v-divider>
<v-toolbar color="white" dense flat>
    <div align-center class="filter-container">
        <div class="filterLabel">Filter</div>
        <div v-if="selection.length" class="filter-divider"></div>
        <v-btn v-if="selection.length" color="primary" flat>Clear all</v-btn>
    </div>
</v-toolbar>
<v-divider></v-divider> -->

</div>
</template>

<style lang="scss" scoped>
$primaryColor: #1565c0;
$dark-charcoal: #222;

.logo {
  display: flex;
  align-items: center;
  color: $primaryColor;
  cursor: pointer;
  .logo-icon {
    margin-right: 5px;
  }
}

.activity-toolbar {
  overflow: hidden;
}

.back {
  margin-left: 0 !important;
}
.search {
  margin-right: 10px !important;
  i {
    font-size: 24px;
  }
}

.search-input {
  flex: 1;
  outline: 0;
}

.filter-container {
  display: flex;
  width: 100%;
  overflow-x: auto;
  align-items: center;
  padding-left: 15px;

  .filter-divider {
    height: 48px;
    min-width: 1px;
    background: #efedef;
  }
}

.searchToolbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fafafa;
  padding: 0 0 0 10px;
  z-index: 1;
}

::-webkit-scrollbar {
  display: none;
}

.divider {
  background-color: #efedef;
}

.slide-fade-enter-active {
  transition: all 0.1s ease-in;
}
.slide-fade-leave-active {
  transition: all 0.1s ease-out;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-48px);
  // opacity: 0;
}

.header-right {
  display: inline-flex;
}
.header-right .chat {
  margin-left: 36px;
  cursor: pointer;
}
.menu__activator--active .username {
  color: $primaryColor;
}
.main-menu-label {
  font-size: 14px;
  line-height: 24px;
  color: $dark-charcoal;
}
.menu-icon {
  font-size: 20px;
  margin-right: 8px;
}
</style>


<script>
import Icon from '@/core/components/Icon'
import each from 'lodash/each'
import isNil from 'lodash/isNil'
import Avatar from '@/core/components/Avatar'

import { mapState } from 'vuex'

export default {
  name: 'OneMobileHeader',
  components: {
    Icon,
    Avatar
  },
  props: {
    selection: {
      type: Array,
      default() {
        return []
      }
    },
    userImageUrl: {
      type: String
    }
  },
  data() {
    return {
      showSearch: false
    }
  },
  methods: {
    toggleSearch() {
      this.showSearch = !this.showSearch
    },
    gotoMainPage() {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    username() {
      return this.user.firstName + ' ' + this.user.lastName
    },
    menuItems() {
      let items = []
      each(this.mainMenu, item => {
        if (isNil(item.condition) || item.condition) {
          items.push(item)
        }
      })
      return items
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/headers/MobileHeader.vue